import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Accordion, AccordionContext, Card, useAccordionButton } from 'react-bootstrap';
import FeatherIcon from 'feather-icons-react';
import classNames from 'classnames';

type CustomToggleProps = {
    children: React.ReactNode;
    eventKey: string;
    containerClass: string;
    linkClass: string;
    callback?: (eventKey: string) => void;
};

const CustomToggle = ({ children, eventKey, containerClass, linkClass, callback }: CustomToggleProps) => {
    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
        <Link
            to="#"
            className={classNames(linkClass, {
                collapsed: !isCurrentEventKey,
            })}
            onClick={decoratedOnClick}
        >
            <Card.Header>
                <h5 className={containerClass}>
                    {children} <FeatherIcon icon="chevron-down" className="icon-xs accordion-arrow" />
                </h5>
            </Card.Header>
        </Link>
    );
};

const FAQContent = () => {
    const faqs = [
      {
        question: "What is SnapAds and how does it work?",
        ans: "SnapAds is a SaaS product designed to enhance Out-Of-Home (OOH) Advertising Platforms. It functions as an all-in-one platform for managing and showcasing hoarding boards to potential leads. Additionally, it offers customers the convenience of visualizing hoarding boards in a map-based view, complete with features such as famous zones, viewing board details, and prebooking.",
      },
      {
        question: "Is there a free trial available?",
        ans: "Yes, there is a free trial available, allowing you to add up to 10 hoarding boards for your Advertisement agency under the Free Forever Plan. If you wish to add more, you can upgrade to other pricing plans or opt for a pay-as-you-go plan.",
      },
      {
        question: "What level of customer support is offered?",
        ans: "We provide knowledge deliverable demo sessions, technical chat support, as well as email and call assistance.",
      },
      {
        question: "Is there a mobile app available for SnapAds?",
        ans: "At the moment, SnapAds is exclusively available as a web application. However, we are constantly evaluating the needs of our users and exploring opportunities for expansion, which may include developing a mobile app in the future. Stay tuned for any updates on our product offerings!",
      },
      {
        question:
          "Can I cancel my subscription at any time? Are there any cancellation fees?",
        ans: " There are no cancellation fees charged. However, you are responsible for paying any applicable usage amounts and dues upon cancellation.",
      },
      //   {
      //     question: "How does billing work for SnapAds?",
      //     ans: "Yes, Use our dedicated support email (support@SnapAds.in) or Phone (+91 8668179904) to send your issues or feedback.We are here to help anytime.",
      //   },
      //   {
      //     question: "Are there any training resources available for new users?",
      //     ans: "Yes, Use our dedicated support email (support@SnapAds.in) or Phone (+91 8668179904) to send your issues or feedback.We are here to help anytime.",
      //   },
    ];

    return (
        <div id="faqContent">
            <Accordion defaultActiveKey="0" className="custom-accordionwitharrow" id="accordionExample">
                {(faqs || []).map((item, index) => {
                    return (
                        <Card className="mb-2 border rounded-sm" key={index.toString()}>
                            <CustomToggle
                                eventKey={String(index)}
                                containerClass="my-1 fw-medium"
                                linkClass="text-dark"
                            >
                                {item.question}
                            </CustomToggle>
                            <Accordion.Collapse eventKey={String(index)}>
                                <Card.Body className="text-muted pt-1">{item.ans}</Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    );
                })}
            </Accordion>
        </div>
    );
};

export default FAQContent;
